export default "__VITE_ASSET__C7oOWPp7__"